/**
 * The four sections of the one screen, in display order.
 *
 * Transcribed from the build strategy (P3), not designed here. Section rules
 * — empty sections collapse, `probably-done` sits below the fold and is capped
 * at five — belong to the ledger surface, not to this constant.
 */
export const LEDGER_SECTIONS = [
  { id: 'you-owe', label: 'You owe' },
  { id: 'youre-waiting-on', label: "You're waiting on" },
  { id: 'may-be-expected', label: 'May be expected' },
  { id: 'probably-done', label: 'Probably done?' },
] as const

export type LedgerSectionId = (typeof LEDGER_SECTIONS)[number]['id']
